module.exports = __webpack_public_path__ + "static/media/customer-info-wait.a545db73.svg";